import React, { useState } from 'react'

import MultiSelectionDropdown from 'components/MultiSelectDropdown'
import { redListOfEcosystemCategory } from 'constants/redListOfEcosystemCategory'

import { FiltersContentContainer } from '../style'
import qs from 'query-string'

const getEcosystemUrl = (defaultList, selectedList, redListCategory ) => {
  const selectedEcosystem = defaultList.filter((element) => {
    return selectedList.some((item) => {
      return item === element.value
    })
  }).map((ecosystem) => {
    return ecosystem.label
  })

  return qs.stringify({
    ecosystem: selectedEcosystem.toString(),
    ecosystemCategory: redListCategory.toString()
  })
}


const EcosystemFiltersContent = ({ item, updateFilters, filterTitle, ecosystemOptions }) => {
  const [ecosystemList, setEcosystemList] = useState(item.ecosystemList)
  const [ecosystemRedListCategory, setEcosystemRedListCategory] = useState(item.ecosystemRedListCategory)
  const [ecosystemQuery, setEcosystemQuery] = useState('')

  const handleChangeEcosystemList = (e) => {
    setEcosystemList(e)
    const url = getEcosystemUrl(ecosystemOptions, e, ecosystemRedListCategory)
    updateFilters({ ...item, ecosystemList: e, url: url }, filterTitle)
  }

  const handleChangeRedListCategory = (e) => {
    setEcosystemRedListCategory(e)
    const url = getEcosystemUrl(ecosystemOptions, ecosystemList, e)
    updateFilters({ ...item, ecosystemRedListCategory: e, url: url }, filterTitle)
  }

  const handleChangeEcosystemQuery = (e) => {
    setEcosystemQuery(e)
  }

  return (
    <FiltersContentContainer>
      <MultiSelectionDropdown
        dataTest='Ecosystem name'
        marginTop='16px'
        label='ecosystemName'
        secondStepOptions={ecosystemOptions}
        value={ecosystemList}
        saveChanges={handleChangeEcosystemList}
        infoTooltip='ecosystemNameFilterHint'
        inputValue={ecosystemQuery}
        onInputChange={handleChangeEcosystemQuery}
        isSearchable={true}
        placeholder='selectEcosystem'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='Ecosystem Red List Category'
        marginTop='16px'
        label='ecosystemRedListCategory'
        secondStepOptions={redListOfEcosystemCategory}
        value={ecosystemRedListCategory}
        saveChanges={handleChangeRedListCategory}
        infoTooltip='ecoRedListCategoryFilterHint'
        placeholder='selectEcosystemRedListCategory'
        selectAllOption={true}
      />
    </FiltersContentContainer>
  )
}

export default EcosystemFiltersContent
